const Status = [
  { label: "未領取", value: "wait_collect", tagColor: "red" },
  { label: "已領取", value: "collected", tagColor: null },
  { label: "待退貨", value: "wait_return", tagColor: "orange" },
  { label: "已退貨", value: "returned", tagColor: null }
];

export const deliveryPackageCodeList = {
  StatusArray: Status,
  StatusMap: Status.reduce((acc, cur) => {
    return { ...acc, [cur.value]: cur };
  }, {})
};
